//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { apis } from 'utils/lib/apis';

//  -- Actions ------------------------
import * as OrganizationActions from './actions';
import { setClassTogglePermission } from './actions';
import { logToSentry } from "utils/networkErrorUtils";
import {map, filter, flatMap} from 'lodash'
import { updateUI } from 'store/UI/actions';

//  ----------------------------------------------------------------------------
//  Thunks
//  ----------------------------------------------------------------------------

//  -- Create organization -------------------
export const handleCreateOrganization = (data) => async (dispatch) => {
    await dispatch(OrganizationActions.createOrganization());

    try {
        const organization = await apis.post('organizationsRDS', `/organizations`, {
            body: { ...data }
        });

        await dispatch(OrganizationActions.createOrganizationSuccess(organization));
        return organization;
    } catch (error) {
        if(error&&error.message!="Network Error"){
            logToSentry({
                message: 'creating organization',
                error,
                module: 'ORGANIZATIONS',
                operation: 'CREATE_ORGANIZATION'
            });
         }
        await dispatch(OrganizationActions.createOrganizationFail(error));
    }
};

//  -- Get organization ----------------------
export const handleGetOrganization = (organizationID) => async (dispatch) => {
    await dispatch(OrganizationActions.getOrganization());
    if(!organizationID) return null;
    try {
        const organization = await apis.get('organizationsRDS', `/organization/${organizationID}`);
            //to be remove
        if(organization&&organization.id){
            sessionStorage.setItem('activeSchoolId',organization.id);
            sessionStorage.setItem('activeDistrictId',organization.parentId);
        }
            //to be remove end
        await dispatch(OrganizationActions.getOrganizationSuccess(organization));
        return organization;
    } catch (error) {
        if(error&&error.message!="Network Error"){
            logToSentry({
                message: 'getting organization',
                error,
                module: 'ORGANIZATIONS',
                operation: 'GET_ORGANIZATION'
            });
         }
        await dispatch(OrganizationActions.getOrganizationFail(error));
    }
};

//  -- List orgs by parent ------------
export const handleListOrgsByParent = (id) => async (dispatch) => {
    await dispatch(OrganizationActions.listOrgsByParent());
    try {
        const organizations = await apis.get('organizationsRDS', `/orgByParent/${id}`);
        await dispatch(OrganizationActions.listOrgsByParentSuccess(organizations));
        return organizations;
    } catch (error) {
        if(error&&error.message!="Network Error"){
            logToSentry({
                message: 'listing orgs by parent',
                error,
                module: 'ORGANIZATIONS',
                operation: 'LIST_ORGANIZATION_BOOK_PREFERENCE'
            });
         }
        await dispatch(OrganizationActions.listOrgsByParentFail(error));
    }
};
export const handleListDashboardInfo = (id) => async (dispatch) => {
    try {
        if(!id) return null;
        const organizations = await apis.get('organizationsRDS', `/district_dash_info/${id}`);
        if (organizations && organizations.statusCode === 200) {
            await dispatch(OrganizationActions.setDistDashboardInfo(organizations));
        }
        return organizations;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'listing dashboard info',
                error,
                module: 'ORGANIZATIONS',
                operation: 'LIST_DEBATE_INSTRUCTION'
            });
        }
        return error;
    }
};
export const handleContentExamGraphData = (config) => async (dispatch) => {
    try {
        const org_data = await apis.post('organizationsRDS', `/content_exam_graph_data`, {
            body: config
        });
        if (org_data && org_data.success === 200) {
            await dispatch(OrganizationActions.setDistContentExamGraphData({
                config:config,
                data:org_data.data || {}
            }));
        }
        return org_data.data ||{};
        //  return typeof org_data.data =="object"? Object.keys(org_data.data).map((key) => ({
        //         "label": key,
        //         "value": org_data.data[key]
        //     })):[];
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error in operation',
                error,
                module: 'ORGANIZATIONS',
                operation: 'CREATE_ORGANIZATION'
            })
        }
        return error;
    }
};
export const handleContentExamBooks = (orgId) => async (dispatch) => {
    try {
        const org_data = await apis.post('organizationsRDS', `/get_books_for_content_exam`, {
            body: {
                orgId:orgId,
                return_complete: false
            }
        });
        return (Array.isArray(org_data)?org_data:[]);
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'listing content exam graph data',
                error,
                module: 'ORGANIZATIONS',
                operation: 'LIST_CLASS_EXAM_GRADE_DATA'
            });
        }
        return error;
    }
};
export const handleListContentExamData = (config) => async (dispatch) => {
    try {
        const organizations = await apis.post('organizationsRDS', `/content_exam_new`, {
            body: config
        });
        // if (organizations && organizations.statusCode === 200) {
        //     await dispatch(OrganizationActions.setDistContentExamGraphData({
        //         config:config,
        //         data:organizations
        //     }));
        // }
        return organizations;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'listing content exam data',
                error,
                module: 'ORGANIZATIONS',
                operation: 'LIST_CLASS_EXAM_DATA'
            });
        }
        return error;
    }
};

export const handleListContentBookData = () => async (dispatch) => {
    try {
        const organizations = await apis.get('organizationsRDS', `/content_exam_book`);
        return organizations;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'listing content book data',
                error,
                module: 'ORGANIZATIONS',
                operation: 'LIST_CLASS_BOOK_DATA'
            });
        }
        return error;
    }
};

export const handleListChapterUnitData = () => async (dispatch) => {
    try {
        const organizations = await apis.get('organizationsRDS', `/get_chapters_with_units`);
        return organizations;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'listing content book data',
                error,
                module: 'ORGANIZATIONS',
                operation: 'LIST_CLASS_BOOK_DATA'
            });
        }
        return error;
    }
};

export const handleGetFilterData = async (orgId  , teacherId , type) =>  {
    try {
        const res = await apis.post('organizationsRDS', `/get_profency_filter`, {
            body: {
               orgId  , teacherId , type
            }
        });

        return res;
    } catch (error) {
        console.error("Error fetching student data:", error);
        return { error: true };
    }
};

export const handleListTeacherClassSubmissions = (data) => async (dispatch) => {
    try {
        const response = await apis.post('standardexams', `/get_teacher_class_submissions`, {
            body: data
        });
        return response;
    } catch (error) {
        return error;
    }
};

export const handleListContentPassingExamData = (config) => async (dispatch) => {
    try {
        const organizations = await apis.post('organizationsRDS', `/passing_per_exam_question`, {
            body: config
        });
        // if (organizations && organizations.statusCode === 200) {
        //     await dispatch(OrganizationActions.setDistContentExamGraphData({
        //         config:config,
        //         data:organizations
        //     }));
        // }
        return organizations;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'listing content passing exam data',
                error,
                module: 'ORGANIZATIONS',
                operation: 'LIST_CLASS_PLACEMENT_EXAM_DATA'
            });
        }
        return error;
    }
};
export const handleListContentPassingExamStudentData = (config) => async (dispatch) => {
    try {
        const organizations = await apis.post('organizationsRDS', `/passing_by_user_ce_by_exam`, {
            body: config
        });
        // if (organizations && organizations.statusCode === 200) {
        //     await dispatch(OrganizationActions.setDistContentExamGraphData({
        //         config:config,
        //         data:organizations
        //     }));
        // }
        return organizations;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'listing content passing exam student data',
                error,
                module: 'ORGANIZATIONS',
                operation: 'LIST_CLASS_PLACEMENT_EXAM_STUDENT_DATA'
            });
        }
        return error;
    }
};
export const handleListbookUsed = (id,data) => async (dispatch) => {
    try {
        const used_data = await apis.post('organizationsRDS', `/list_book_used/${id}`,{
            body: data
        });
        if (Array.isArray(used_data)) {
            await dispatch(OrganizationActions.updateDistBookUsesGraphData({
                key:'text_books_uses',
                config:data,
                data:used_data
            }));
        }
        return used_data;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'listing book used',
                error,
                module: 'ORGANIZATIONS',
                operation: 'LIST_BOOK_USER'
            });
        }
        return error;
    }
};
export const handleListSublimentUsedbookUsed = (id,data) => async (dispatch) => {
    try {
        const used_data = await apis.post('organizationsRDS', `/list_supliments_uses/${id}`,{
            body: data
        });
        if (Array.isArray(used_data)) {
            await dispatch(OrganizationActions.updateDistBookUsesGraphData({
                key:'supliment_books_uses',
                config:data,
                data:used_data
            }));
        }
        return used_data;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'listing book used',
                error,
                module: 'ORGANIZATIONS',
                operation: 'LIST_BOOK_USER'
            });
        }
        return error;
    }
};
export const handleListbookUsedForSuperAdmin = (data) => async (dispatch) => {
    try {
        const used_data = await apis.post('organizationsRDS', `/used_book_data`,{
            body: data
        });
        if (Array.isArray(used_data)) {
           await dispatch(OrganizationActions.updateDistBookUsesGraphData({
                key:'text_books_uses',
                config:data,
                data:used_data
            }));
        }
        return used_data;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'listing book used',
                error,
                module: 'ORGANIZATIONS',
                operation: 'LIST_BOOK_USER'
            });
        }
        return error;
    }
};
export const handleListSuplimentbookUsedForSuperAdmin = (data) => async (dispatch) => {
    try {
        const used_data = await apis.post('organizationsRDS', `/list_supliments_uses/all`,{
            body: data
        });
        if (Array.isArray(used_data)) {
           await dispatch(OrganizationActions.updateDistBookUsesGraphData({
                key:'supliment_books_uses',
                config:data,
                data:used_data
            }));
        }
        return used_data;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'listing book used',
                error,
                module: 'ORGANIZATIONS',
                operation: 'LIST_BOOK_USER'
            });
        }
        return error;
    }
};

//  -- List orgs by parent ------------
export const handleListGetSchool = (id) => async (dispatch) => {
    await dispatch(OrganizationActions.listOrgsByParent());
    try {
        const organizations = await apis.get('organizationsRDS', `/getSchool/${id}`);
        await dispatch(OrganizationActions.listOrgsByParentSuccess(organizations));
        return organizations;
    } catch (error) {
        if(error&&error.message!="Network Error"){
            logToSentry({
                message: 'listing get school',
                error,
                module: 'ORGANIZATIONS',
                operation: 'LIST_GROUP_STUDENT'
            });
         }
        await dispatch(OrganizationActions.listOrgsByParentFail(error));
    }
};

//  -- List organizations -------------------

// get district with correct counts --------------------------------
export const handleGetDistrictsWithCount = () => async (dispatch) => {
    await dispatch(OrganizationActions.listDistricts());
    const DISTRICT_LENGTH = 100;
    try {
        const numberOfDistrict = await apis.get('organizationsRDS', `/listAllOrgLength/district`);
        const districtArr = Array.apply(
            0,
            new Array(Math.floor(numberOfDistrict.length / DISTRICT_LENGTH) + 1)
          ).map((k, i) => i);
          const allOrganization = await Promise.allSettled(
            map(districtArr, async (k) => {
              return apis.get("organizationsRDS", `/getDistrict/${DISTRICT_LENGTH}/${k * DISTRICT_LENGTH}`);
            })
          ).then((v) => filter(v, ["status", "fulfilled"]).map((k) => k.value));
          const organizations = flatMap(allOrganization);
        await dispatch(OrganizationActions.listDistrictsSuccess(organizations));
        return organizations;
    } catch (error) {
        if(error&&error.message!="Network Error"){
            logToSentry({
                message: 'listing districts with count',
                error,
                module: 'ORGANIZATIONS',
                operation: 'LIST_DEBATE_WORKSHEET_CONTENT'
            });
         }
        await dispatch(OrganizationActions.listDistrictsFail(error));
        return [];
    }
};

// get district with correct counts --------------------------------
// export const handleGetDistrictsWithCount = (data) => async (dispatch) => {
//     await dispatch(OrganizationActions.listDistricts());
//     try {
//         const organizations = await apis.get("organizationsRDS", `/getDistrict/${data.limit}/${data.offset}`);
//         await dispatch(OrganizationActions.listDistrictsSuccess(organizations));
//         return organizations;
//     } catch (error) {
//         if(error&&error.message!="Network Error"){
//             logToSentry({
//                 message: 'Error in operation',
//                 error,
//                 module: 'ORGANIZATIONS',
//                 operation: 'GET_ORGANIZATION'
//             })
//          }
//         await dispatch(OrganizationActions.listDistrictsFail(error));
//     }
// };

//  -- List organizations School -------------------
export const handleListSchools = () => async (dispatch) => {
    await dispatch(OrganizationActions.listAllSchools());
    const ORGANIZATION_LENGTH = 500;
    try {
        const numberOfOrg = await apis.get('organizationsRDS', `/listAllOrgLength/school`);
        const organizationArr = Array.apply(
            0,
            new Array(Math.floor(numberOfOrg.length / ORGANIZATION_LENGTH) + 1)
          ).map((k, i) => i);
          const allOrganization = await Promise.allSettled(
            map(organizationArr, async (k) => {
              return apis.get("organizationsRDS", `/listAllOrg/school/${ORGANIZATION_LENGTH}/${k * ORGANIZATION_LENGTH}`);
            })
          ).then((v) => filter(v, ["status", "fulfilled"]).map((k) => k.value));
          // const organizations = await apis.get('organizationsRDS', `/listAllOrg/school/10/1`);
          const organizations = flatMap(allOrganization);
        await dispatch(OrganizationActions.listAllSchoolsSuccess(organizations));
        return organizations;
    } catch (error) {
        if(error&&error.message!="Network Error"){
            logToSentry({
                message: 'listing all schools',
                error,
                module: 'ORGANIZATIONS',
                operation: 'LIST_ACTIVITY_STUDENT'
            });
         }
        await dispatch(OrganizationActions.listAllSchoolsFail(error));
    }
};




//  -- Update organization -------------------
export const handleUpdateOrganization = (organizationID, data) => async (dispatch) => {
    await dispatch(OrganizationActions.updateOrganization());
    
    try {
       const res = await apis.put('organizationsRDS', `/organizations/${organizationID}`, {
            body: { ...data }
        });
   

        await dispatch(OrganizationActions.updateOrganizationSuccess({ id: organizationID, ...data }));
        return res;
    } catch (error) {
        if(error&&error.message!="Network Error"){
            logToSentry({
                message: 'updating organization',
                error,
                module: 'ORGANIZATIONS',
                operation: 'UPDATE_ORGANIZATION'
            });
         }
        await dispatch(OrganizationActions.updateOrganizationFail(error));
    }
};

export const handleDeleteUserFromOrganization = (organizationID, users) => async (dispatch) => {
    if (!organizationID || !users || !users?.length) return;
    try {
        await apis.post('organizationsRDS', `/deleteUserFromOrg`, {
            body: { users, orgId: organizationID }
        });
    } catch (error) {
        if(error&&error.message!="Network Error"){
            logToSentry({
                message: 'deleting user from organization',
                error,
                module: 'ORGANIZATIONS',
                operation: 'DELETE_USER_FEEDBACK_ORGANIZATION'
            });
         }
        console.log('error', error);
    }
};


export const getOrganizationById = async (orgId) => {
    try {
        if(!orgId) return {};
        const org = await apis.get('organizationsRDS', `/organization/${orgId}`);
        return org;
    } catch (error) {
        return {};
    }
}


export const handleUpdateLicences = async (orgId) =>{
    try {
        return await apis.get("organizationsRDS", `/licensesUpdate/${orgId}`);
       } catch (error) {
           if(error&&error.message!="Network Error"){
               logToSentry({
                message: 'updating licences',
                error,
                module: 'ORGANIZATIONS',
                operation: 'UPDATE_LESSON'
            });
            }
           return ({error})
       }
}
export const handleUpdateVocabPermission = async (data) => {
    try {
        return await apis.post("orgPermissions", `/vocab_permission/update_access`, {
            body: data
        });
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'updating vocab permission',
                error,
                module: 'ORGANIZATIONS',
                operation: 'UPDATE_VOCABULARY_PREFERENCE'
            });
        }
        return ({ error })
    }
}
export const handleGetVocabPermission = async (id) => {
    try {
        return await apis.get("orgPermissions", `/vocab_permission/get/${id}`);
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'getting vocab permission',
                error,
                module: 'ORGANIZATIONS',
                operation: 'GET_VOCABULARY_PREFERENCE'
            });
        }
        return ({ error })
    }
}
export const handleGetOrgPermissionPermission =  (id) => async (dispatch) => {
    try {
        if(!id) return;
        const data = await apis.get("orgPermissions", `/orgPermissions/${id}`);
        if(data){
            dispatch(updateUI({ orgPermission: data }));
            dispatch(OrganizationActions.getOrganizationPermissionSuccess(data));
            return data;
        }
        return data;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: '967-b Error getting org_permission permission',
                error,
                module: 'ORGANIZATIONS',
                operation: 'EXPORT_GRADE_ORGANIZATION_PREFERENCE'
            });
        }
        return ({ error })
    }
}
export const handleGetVocabPermissionForStudent =  (user_id,class_id) => async (dispatch) => {
    try {
        const data = await apis.post("orgPermissions", `/vocab_permission/get_for_student/${user_id}`,{
            body: { user_id ,class_id }
        });
        if (data && data.success) {
            await dispatch(OrganizationActions.setVocabPermissionForUser(data?.data));
        }
        return data;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'getting vocab permission for student',
                error,
                module: 'ORGANIZATIONS',
                operation: 'GET_VOCABULARY_PREFERENCE_FEEDBACK_STUDENT'
            });
        }
        return ({ error })
    }
}

export const handleGetGlobalUserSearch =  (data) => async (dispatch) => {
    try {
        const dataSearch = await apis.post("organizationsRDS", `/global_user_search`,{
            body: data
        });
        
        return dataSearch;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error in operation',
                error,
                module: 'ORGANIZATIONS',
                operation: 'LIST_ORGS_BY_PARENT'
            })
        }
        return ({ error })
    }
}

export const handleGetGlobalUserDetail = async (id) => {
    try {
        const dataSearch = await apis.get("organizationsRDS", `/admin_global_search_detail/${id}`);
        
        return dataSearch;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error in operation',
                error,
                module: 'ORGANIZATIONS',
                operation: 'LIST_DASHBOARD_INFO'
            })
        }
        return ({ error })
    }
}

export const handleGetArchiveOrganization =  (data) => async (dispatch) => {
    try {
        const dataArchive = await apis.post("organizationsRDS", `/archive_organization`,{
            body: data
        });
        await dispatch(OrganizationActions.updateDistrictsSuccess(dataArchive));
        return dataArchive;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error in operation',
                error,
                module: 'ORGANIZATIONS',
                operation: 'CONTENT_EXAM_GRAPH_DATA'
            })
        }
        return ({ error })
    }
}



export const handleListExamGraphData = (data) => async (dispatch) => {
    try {
        const result = await apis.post('organizationsRDS', `/overall_exam_graph_data`, {
            body: data
        });
        if(result&&result.success){
            await dispatch(OrganizationActions.setDistExamGraphData({
                config: data,
                data: result.data
            }));
        }
        return result.data;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error in operation',
                error,
                module: 'ORGANIZATIONS',
                operation: 'CONTENT_EXAM_BOOKS'
            })
        }
        return null;
    }
};

export const handleListExamClassGraphData = (data) => async (dispatch) => {
    try {
        const result = await apis.post('organizationsRDS', `/overall_exam_graph_class_data`, {
            body: data
        });
        if(result&&result.success){
            await dispatch(OrganizationActions.setDistExamGraphData({
                config: data,
                data: result.data
            }));
        }
        return result.data;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error in operation',
                error,
                module: 'ORGANIZATIONS',
                operation: 'LIST_CONTENT_EXAM_DATA'
            })
        }
        return null;
    }
};

export const handleListApExamGraphData = (data) => async (dispatch) => {
    try {
        const result = await apis.post('organizationsRDS', `/ap_exam_graph_data`, {
            body: data
        });
        // if(result&&result.success){
        //     await dispatch(OrganizationActions.setDistExamGraphData({
        //         config: data,
        //         data: result.data
        //     }));
        // }
        if(result&&result.success){
            return Object.keys(result.data).map((key) => ({
                "label": key,
                "value": result.data[key]
            }));
        }
        return result.data;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error in operation',
                error,
                module: 'ORGANIZATIONS',
                operation: 'LIST_CONTENT_BOOK_DATA'
            })
        }
        return null;
    }
};


export const handleGetSchoolsForOrg = (offset, limit, orgId) => async (dispatch) => {

    try {
        const res = await apis.post('organizationsRDS', `/get_schools_for_org`, {
            body: { offset, limit, orgId }
        });
        return res;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error in fetching school information for organization',
                error,
                module: 'ORGANIZATIONS',
                operation: 'FETCH_SCHOOL_INFO'
            });
        }
        return ({ error: true })
    }
};

export const handleGetSchoolsListForCreateUser = async(orgId) => {

    try {
        const res = await apis.post('organizationsRDS', `/list_school_for_create_user`, {
            body: { orgId }
        });
        return res;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error in fetching school information for organization',
                error,
                module: 'ORGANIZATIONS',
                operation: 'FETCH_SCHOOL_INFO'
            });
        }
        return ({ error: true })
    }
};
export const handleGetUsersListForCreateUser = async(orgId,role) =>  {

    try {
        const res = await apis.post('organizationsRDS', `/list_users_for_create_user`, {
            body: { orgId ,role }
        });
        return res;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error in fetching school information for organization',
                error,
                module: 'ORGANIZATIONS',
                operation: 'FETCH_SCHOOL_INFO'
            });
        }
        return ({ error: true })
    }
};
export const handleGetTeacherForOrg = (offset, limit, orgId , demo_status) => async (dispatch) => {

    try {
        const res = await apis.post('organizationsRDS', `/get_teacher_by_org`, {
            body: { offset, limit, orgId , demo_status }
        });
        return res;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error in fetching school information for organization',
                error,
                module: 'ORGANIZATIONS',
                operation: 'FETCH_SCHOOL_INFO'
            });
        }
        return ({ error: true })
    }
};
export const handleGetStudentForOrg = (offset, limit, orgId,demo_status) => async (dispatch) => {

    try {
        const res = await apis.post('organizationsRDS', `/get_students_for_org`, {
            body: { offset, limit, orgId , demo_status }
        });
        return res;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error in fetching school information for organization',
                error,
                module: 'ORGANIZATIONS',
                operation: 'FETCH_SCHOOL_INFO'
            });
        }
        return ({ error: true })
    }
};
export const handleGetParentForOrg = (offset, limit, orgId) => async (dispatch) => {

    try {
        const res = await apis.post('organizationsRDS', `/get_parent_for_org`, {
            body: { offset, limit, orgId }
        });
        return res;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error in fetching school information for organization',
                error,
                module: 'ORGANIZATIONS',
                operation: 'FETCH_SCHOOL_INFO'
            });
        }
        return ({ error: true })
    }
};
export const handleGetDistrictAdminForOrg = (offset, limit, orgId , role ) => async (dispatch) => {

    try {
        const res = await apis.post('organizationsRDS', `/get_district_admin_of_org`, {
            body: { offset, limit, orgId , role }
        });
        return res;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error in fetching school information for organization',
                error,
                module: 'ORGANIZATIONS',
                operation: 'FETCH_SCHOOL_INFO'
            });
        }
        return ({ error: true })
    }
};
export const handleGetClassesForOrg = (offset, limit, orgId) => async (dispatch) => {

    try {
        const res = await apis.post('organizationsRDS', `/get_classes_for_org`, {
            body: { offset, limit, orgId }
        });
        return res;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error in fetching school information for organization',
                error,
                module: 'ORGANIZATIONS',
                operation: 'FETCH_SCHOOL_INFO'
            });
        }
        return ({ error: true })
    }
};
export const handleGetTeacherForSchool = (orgId) => async (dispatch) => {

    try {
        const res = await apis.get('organizationsRDS', `/get_teacher_for_school/${orgId}`);
        return res;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error in fetching school information for organization',
                error,
                module: 'ORGANIZATIONS',
                operation: 'FETCH_SCHOOL_INFO'
            });
        }
        return ({ error: true })
    }
};

// store/organizations/thunks.js

export const handleSearchUserForOrg = (offset, limit, orgId, isDemo = false, search = '' , role='student') => async (dispatch) => {
    try {
        const res = await apis.post('organizationsRDS', `/search_user`, {
            body: {
                offset,
                limit,
                demo_status: isDemo,
                role,
                search,
                orgId
            }
        });

        return res;
    } catch (error) {
        console.error("Error fetching student data:", error);
        return { error: true };
    }
};

export const handleGetClassTogglePermission = (class_id, teacher_id) => async (dispatch) => {
    try {
        const response = await apis.get("orgPermissions", `/classTogglePermission/${class_id}/${teacher_id}`);
        if (response && !response.error) {
            dispatch(setClassTogglePermission(response.data || { en_sp: {}, vocabulary: {}, cognates: {} }));
        }
        return response;
    } catch (error) {
        if(error&&error.message!="Network Error"){
            logToSentry({
                message: 'getting class toggle permission',
                error,
                module: 'ORGANIZATIONS',
                operation: 'GET_CLASS_TEACHER_PREFERENCE'
            });
        }
        return ({error})
    }
}

export const handleUpdateClassTogglePermission = async (data) => {
    try {
        return await apis.post("orgPermissions", `/classTogglePermission`, {
            body: data
        });
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'updating class toggle permission',
                error,
                module: 'ORGANIZATIONS',
                operation: 'UPDATE_CLASS_TEACHER_PREFERENCE'
            });
        }
        return ({ error })
    }
}

